import { render, staticRenderFns } from "./CompanyAssetsManager.vue?vue&type=template&id=678b3c12&scoped=true"
import script from "./CompanyAssetsManager.vue?vue&type=script&lang=js"
export * from "./CompanyAssetsManager.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssetsManager.vue?vue&type=style&index=0&id=678b3c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b3c12",
  null
  
)

export default component.exports